export const CNI = "CNI";
export const RIB = "RIB";
